// src/firebase/firebaseConfig.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const LOCAL_PREVIEW_BUILD = process.env.REACT_APP_PWG_PRODUCTION_RELEASE !== "1";
const isLocalhost =
  LOCAL_PREVIEW_BUILD &&
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

// Localhost should not silently force emulator mode. This allows the local UI
// to test the deployed API with real Firebase ID tokens. Opt in explicitly
// when emulator testing is desired.
const useFirebaseEmulators =
  LOCAL_PREVIEW_BUILD && isLocalhost &&
  String(process.env.REACT_APP_USE_FIREBASE_EMULATORS || "").toLowerCase() === "true";

const firebaseConfig = {
  apiKey: "AIzaSyBoou_q39UFp_MUPhkqCvjso2GuxtbElOA",
  authDomain: "playswithguru-27598.firebaseapp.com", // keep the real domain
  projectId: "playswithguru-27598",
  storageBucket: "playswithguru-27598.appspot.com",
  messagingSenderId: "751529029573",
  appId: "1:751529029573:web:0a9dfacb9cfb42b21c25ac",
  measurementId: "G-JN6L4GD073",
};

console.log("Firebase Init Config:", { ...firebaseConfig, apiKey: "[redacted]" });

export const app = getApps()[0] ?? initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

// Prevent double-connects during HMR / StrictMode
if (useFirebaseEmulators && !window.__FIREBASE_EMULATORS_CONNECTED__) {
  window.__FIREBASE_EMULATORS_CONNECTED__ = true;
  console.log("Connecting to Firebase emulators…");
  try { connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true }); } catch {}
  try { connectFirestoreEmulator(db, "localhost", 8080); } catch {}
  try { connectFunctionsEmulator(functions, "localhost", 5501); } catch {}
  console.log("[firebase] Emulators connected: auth:9099, db:8080, fn:5501");
}
else {
  console.log("[firebase] Using production Firebase.");
}
